import { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import GenericTwoFactorErrorAlert from 'LoginUI/components/alerts/GenericTwoFactorErrorAlert';
import BlockedLoginMethodAlert from 'LoginUI/components/alerts/BlockedLoginMethodAlert';
import InvalidCodeAlert from 'LoginUI/components/alerts/InvalidCodeAlert';
import NewCodeSentAlert from 'LoginUI/components/alerts/NewCodeSentAlert';
import SmsRateLimitAlert from 'LoginUI/components/alerts/SmsRateLimitAlert';
import RestrictedIpAddressAlert from 'LoginUI/components/alerts/RestrictedIpAddressAlert';
import ConfirmToLoginError from 'LoginUI/components/alerts/ConfirmToLoginError';
import HubspotAuthenticatorError from 'LoginUI/components/alerts/HubspotAuthenticatorError';
import NewCodeSentToEmailAlert from 'LoginUI/components/alerts/NewCodeSentToEmailAlert';
import TwoFactorAuthLevels from 'LoginUI/constants/TwoFactorAuthLevels';
import TwoFactorAuthAppStates from 'LoginUI/constants/TwoFactorAuthAppStates';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
import ImageUrl from 'LoginUI/images/imageUrls';
import { BackButton } from 'foundations-components/transitional/components/BackButton';
import { Link } from 'foundations-components/transitional/components/Link';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Flex } from 'foundations-components/components/Flex';
import { Image } from 'foundations-components/transitional/components/Image';
import { View } from 'foundations-components/components/View';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { Text } from 'foundations-components/components/Text';
import { Spacer } from 'foundations-components/components/Spacer';
import { Box } from 'foundations-components/transitional/components/Box';
import { Tile, TileSection } from 'foundations-components/transitional/components/Tile';
import { CONFIRM_TO_LOGIN_KEY, TWO_FACTOR_KEY } from 'LoginUI/constants/CodeEntryKeyWords';
import { CANT_FIND_EMAIL_KB } from 'LoginUI/constants/KnowledgeBaseUrls';
import UserDeactivatedAlert from 'LoginUI/components/alerts/UserDeactivatedAlert';
import { trackTwoFactorRecoveryMobileAuth } from 'LoginUI/lib/tracker';
import AppLogo from 'LoginUI/components/AppLogo';
// @ts-expect-error no types from package
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const RECOVERY_REASONS = ['new', 'lost', 'uninstalled'];
const validatingProps = (keyWord, type) => {
  return (props, propName, componentName) => {
    if (props.keyWord !== keyWord) {
      return null;
    }
    if (typeof props[propName] === type) {
      return null;
    }
    return new Error(`Invalid prop ${propName} passed to ${componentName}. Expected ${propName} to be a ${type}.`);
  };
};
export default class CodeEntryForm extends Component {
  constructor(...args) {
    super(...args);
    this.renderCodeEntry = () => {
      if (this.props.keyWord === TWO_FACTOR_KEY && this.props.isHubspotAuthenticator && this.props.appState !== TwoFactorAuthAppStates.BACKUP) {
        return /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsxs(AccordionItem, {
            title: /*#__PURE__*/_jsx(Link, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "login.twoFactor.questionHubspotApp"
              })
            }),
            marginBlockStart: "700",
            children: [/*#__PURE__*/_jsx(Text, {
              marginBlockStart: "500",
              children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                message: "login.twoFactor.descriptionHubspotApp"
              })
            }), /*#__PURE__*/_jsxs(TFlex, {
              direction: "row",
              wrap: "wrap",
              align: "end",
              justify: "between",
              children: [/*#__PURE__*/_jsx(Box, {
                basis: 300,
                shrink: 0,
                children: this.renderImage()
              }), /*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsxs(View, {
                  inlineSize: "200px",
                  marginBlockEnd: "400",
                  children: [/*#__PURE__*/_jsx(FormLabel, {
                    htmlFor: "code",
                    children: I18n.text(`login.${this.props.keyWord}.inputLabel`)
                  }), /*#__PURE__*/_jsx(TextInput, {
                    autoFocus: true,
                    id: "code",
                    onChange: this.props.onCodeChange
                    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
                    ,
                    tabIndex: "1",
                    maxLength: this.props.codeLength,
                    value: this.props.inputValue,
                    disabled: this.props.isVerifying || this.props.isRequestingCode
                  })]
                }), this.props.renderSubmitButton(), /*#__PURE__*/_jsx(Spacer, {
                  space: "200"
                })]
              })]
            }), /*#__PURE__*/_jsx(Spacer, {}), this.renderLostDeviceTile()]
          })
        });
      } else {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormLabel, {
            htmlFor: "code",
            children: I18n.text(`login.${this.props.keyWord}.inputLabel`)
          }), /*#__PURE__*/_jsx(View, {
            inlineSize: "200px",
            marginBlockEnd: "400",
            children: /*#__PURE__*/_jsx(TextInput, {
              autoFocus: true,
              id: "code",
              onChange: this.props.onCodeChange
              // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
              ,
              tabIndex: "1",
              maxLength: this.props.codeLength,
              value: this.props.inputValue,
              disabled: this.props.isVerifying || this.props.isRequestingCode
            })
          })]
        });
      }
    };
    this.renderLostDeviceTile = () => {
      const {
        onLostDevice
      } = this.props;
      const onClickLostDeviceHandler = reason => {
        if (onLostDevice) {
          trackTwoFactorRecoveryMobileAuth(reason);
          onLostDevice();
        }
      };
      const divider = /*#__PURE__*/_jsx(View, {
        paddingInline: "300",
        children: "|"
      });
      return /*#__PURE__*/_jsxs(Tile, {
        compact: true,
        children: [/*#__PURE__*/_jsxs(TileSection, {
          children: [/*#__PURE__*/_jsx("b", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `login.twoFactor.mobileAppLostDevice.title`
            })
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
            message: `login.twoFactor.mobileAppLostDevice.body`
          })]
        }), /*#__PURE__*/_jsx(TileSection, {
          children: /*#__PURE__*/_jsx(Flex, {
            flexDirection: "row",
            flexWrap: "wrap",
            children: RECOVERY_REASONS.map((reason, key) => {
              return /*#__PURE__*/_jsxs(Flex, {
                flexDirection: "row",
                children: [key !== 0 && divider, /*#__PURE__*/_jsx(Button, {
                  use: "link",
                  onClick: () => {
                    onClickLostDeviceHandler(reason);
                  },
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: `login.twoFactor.mobileAppRecovery.${reason}`
                  })
                })]
              }, key);
            })
          })
        })]
      });
    };
    this.renderSmsRetry = () => {
      if (this.props.keyWord !== TWO_FACTOR_KEY) {
        return null;
      }
      const {
        retryCode
      } = this.props;
      if (!this.props.shouldRenderFooter) {
        return null;
      }
      const smsRetry = this.props.isSms && /*#__PURE__*/_jsx("a", {
        onClick: retryCode,
        children: I18n.text('login.twoFactor.phoneAuth.newCode')
      });
      return /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx("p", {
          children: smsRetry
        })
      });
    };
    this.renderAlerts = () => {
      const {
        keyWord,
        error,
        newCodeSentAlertVisible,
        dismissNewCodeSentAlert,
        email,
        vettingUrl
      } = this.props;
      switch (keyWord) {
        case TWO_FACTOR_KEY:
          return [/*#__PURE__*/_jsx(GenericTwoFactorErrorAlert, {}, 1), /*#__PURE__*/_jsx(InvalidCodeAlert, {}, 2), /*#__PURE__*/_jsx(NewCodeSentAlert, {}, 3), /*#__PURE__*/_jsx(SmsRateLimitAlert, {}, 4), /*#__PURE__*/_jsx(UserDeactivatedAlert, {}, 5), /*#__PURE__*/_jsx(BlockedLoginMethodAlert, {}, 6), /*#__PURE__*/_jsx(RestrictedIpAddressAlert, {}, 7)];
        case CONFIRM_TO_LOGIN_KEY:
          return [/*#__PURE__*/_jsx(ConfirmToLoginError, {
            error: error,
            keyWord: keyWord,
            vettingUrl: vettingUrl
          }, 7), /*#__PURE__*/_jsx(NewCodeSentToEmailAlert, {
            newCodeSentAlertVisible: newCodeSentAlertVisible,
            dismissNewCodeSentAlert: dismissNewCodeSentAlert,
            email: email,
            keyWord: keyWord
          }, 8)];
        default:
          return null;
      }
    };
    this.renderRecoveryLink = () => {
      const {
        keyWord,
        onLostDevice,
        isHubspotAuthenticator
      } = this.props;
      if (keyWord !== TWO_FACTOR_KEY || isHubspotAuthenticator) {
        return null;
      }
      return /*#__PURE__*/_jsx("a", {
        "data-test-id": "2fa-lost-device-button",
        onClick: onLostDevice,
        children: I18n.text('login.twoFactor.lostDevice')
      });
    };
    this.renderFooter = () => {
      const {
        switchVerificationMethod,
        hasSecondaryMethod,
        twoFactorLevel,
        switchAppState,
        appState,
        backupCodesEnabled,
        areBothGoogleAuth,
        keyWord,
        isSms,
        callForCode
      } = this.props;
      if (keyWord !== TWO_FACTOR_KEY) {
        return null;
      }
      if (!this.props.shouldRenderFooter) {
        return /*#__PURE__*/_jsx("div", {
          children: this.renderRecoveryLink()
        });
      }
      let switchMethods;
      let backupCode;
      let switchToPrimary;
      let switchToSecondary;
      if (appState === TwoFactorAuthAppStates.DEFAULT && switchAppState) {
        const backupVerificationMethodMessage = twoFactorLevel === TwoFactorAuthLevels.PRIMARY ? I18n.text('login.twoFactor.secondary') : I18n.text('login.twoFactor.primary');
        switchMethods = hasSecondaryMethod && !areBothGoogleAuth && /*#__PURE__*/_jsx("a", {
          "data-test-id": "switch-2fa-verification-method-button",
          onClick: switchVerificationMethod,
          children: backupVerificationMethodMessage
        });
        backupCode = backupCodesEnabled && /*#__PURE__*/_jsx("a", {
          onClick: () => {
            switchAppState();
          },
          children: I18n.text('login.twoFactor.backupCode.footer')
        });
      } else if (switchAppState) {
        switchToPrimary = /*#__PURE__*/_jsx("a", {
          onClick: () => {
            switchAppState(TwoFactorAuthLevels.PRIMARY);
          },
          children: I18n.text('login.twoFactor.primary')
        });
        switchToSecondary = hasSecondaryMethod && /*#__PURE__*/_jsx("a", {
          onClick: () => {
            switchAppState(TwoFactorAuthLevels.SECONDARY);
          },
          children: I18n.text('login.twoFactor.secondary')
        });
      }
      const callForTheCode = isSms && callForCode ? /*#__PURE__*/_jsx("a", {
        onClick: () => {
          callForCode();
        },
        children: I18n.text('login.twoFactor.phoneAuth.callForCode')
      }) : null;
      return /*#__PURE__*/_jsxs(View, {
        marginBlock: "400",
        children: [I18n.text('login.twoFactor.footerQuestion'), /*#__PURE__*/_jsx(Spacer, {
          space: "200"
        }), /*#__PURE__*/_jsxs(TFlex, {
          direction: "column",
          children: [callForTheCode, switchMethods, backupCode, switchToPrimary, switchToSecondary, this.renderRecoveryLink()]
        })]
      });
    };
    this.renderGetNewCode = () => {
      const {
        keyWord,
        onGetNewCode
      } = this.props;
      if (keyWord !== CONFIRM_TO_LOGIN_KEY || !onGetNewCode) {
        return null;
      }
      return /*#__PURE__*/_jsx(View, {
        marginBlock: "600",
        children: /*#__PURE__*/_jsx(Button, {
          use: "link",
          onClick: onGetNewCode,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "login.confirmToLogin.newCode"
          })
        })
      });
    };
    this.renderTroubleshootLink = () => {
      const {
        keyWord
      } = this.props;
      if (keyWord !== CONFIRM_TO_LOGIN_KEY) {
        return null;
      }
      return /*#__PURE__*/_jsx(KnowledgeBaseButton, {
        url: CANT_FIND_EMAIL_KB,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "login.confirmToLogin.troubleshoot"
        })
      });
    };
    this.renderImage = () => {
      return /*#__PURE__*/_jsx(Image, {
        src: ImageUrl.hubspotMobileApp,
        alt: "Hubspot App Screen",
        marginBlockStart: "400"
      });
    };
    this.renderSubmit = () => {
      if (this.props.keyWord === TWO_FACTOR_KEY) {
        if (!this.props.isHubspotAuthenticator || this.props.appState === TwoFactorAuthAppStates.BACKUP) {
          return true;
        }
        return false;
      } else {
        return true;
      }
    };
  }
  render() {
    const keyWord = this.props.keyWord;
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(AppLogo, {
        logoWidth: "128px",
        logoAlignment: "start",
        logoPadding: "300",
        children: /*#__PURE__*/_jsx(BackButton, {
          children: /*#__PURE__*/_jsx(Link, {
            onClick: this.props.onReturnToLogin,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "login.confirmToLogin.loginReturn"
            })
          })
        })
      }), /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        alignSelf: "center",
        flexWrap: "wrap",
        padding: "1400",
        children: [/*#__PURE__*/_jsx(Box, {
          basis: 545,
          shrink: 1,
          children: /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx("h1", {
                children: this.props.header
              }), /*#__PURE__*/_jsx(HubspotAuthenticatorError, {
                restartTimer: this.props.onRestartTimer
              }), /*#__PURE__*/_jsx("p", {
                children: this.props.description
              }), this.renderTroubleshootLink()]
            }), /*#__PURE__*/_jsxs("form", {
              id: "hs-login",
              onSubmit: this.props.onSubmit,
              children: [this.renderCodeEntry(), this.renderGetNewCode(), this.renderSmsRetry(), /*#__PURE__*/_jsx(View, {
                marginBlock: "600",
                children: this.renderAlerts()
              }), this.renderSubmit() && this.props.renderSubmitButton()]
            }), this.renderFooter()]
          })
        }), /*#__PURE__*/_jsx(Box, {
          basis: 150
        }), /*#__PURE__*/_jsx(Box, {
          children: /*#__PURE__*/_jsxs(Text, {
            textAlign: "center",
            children: [this.props.renderIllustration(), /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx("div", {
                children: I18n.text(`login.${keyWord}.explanationText`)
              }), /*#__PURE__*/_jsx("div", {
                children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                  message: `login.${keyWord}.knowledgeBase`
                })
              })]
            })]
          })
        })]
      })]
    });
  }
}
CodeEntryForm.propTypes = {
  areBothGoogleAuth: validatingProps(TWO_FACTOR_KEY, 'boolean'),
  appState: validatingProps(TWO_FACTOR_KEY, 'string'),
  backupCodesEnabled: validatingProps(TWO_FACTOR_KEY, 'boolean'),
  description: PropTypes.element,
  codeLength: PropTypes.number.isRequired,
  hasSecondaryMethod: validatingProps(TWO_FACTOR_KEY, 'boolean'),
  header: PropTypes.element.isRequired,
  inputValue: PropTypes.string.isRequired,
  isRequestingCode: PropTypes.bool.isRequired,
  isSms: validatingProps(TWO_FACTOR_KEY, 'boolean'),
  isHubspotAuthenticator: validatingProps(TWO_FACTOR_KEY, 'boolean'),
  isVerifying: PropTypes.bool.isRequired,
  keyWord: PropTypes.string.isRequired,
  onCodeChange: PropTypes.func.isRequired,
  onLostDevice: validatingProps(TWO_FACTOR_KEY, 'function'),
  onReturnToLogin: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  renderIllustration: PropTypes.func.isRequired,
  renderSubmitButton: PropTypes.func.isRequired,
  retryCode: validatingProps(TWO_FACTOR_KEY, 'function'),
  callForCode: validatingProps(TWO_FACTOR_KEY, 'function'),
  switchAppState: validatingProps(TWO_FACTOR_KEY, 'function'),
  switchVerificationMethod: validatingProps(TWO_FACTOR_KEY, 'function'),
  twoFactorLevel: validatingProps(TWO_FACTOR_KEY, 'string'),
  dismissNewCodeSentAlert: validatingProps(CONFIRM_TO_LOGIN_KEY, 'function'),
  email: PropTypes.string,
  error: PropTypes.string,
  newCodeSentAlertVisible: validatingProps(CONFIRM_TO_LOGIN_KEY, 'boolean'),
  onGetNewCode: validatingProps(CONFIRM_TO_LOGIN_KEY, 'function'),
  shouldRenderFooter: validatingProps(TWO_FACTOR_KEY, 'boolean'),
  onRestartTimer: validatingProps(TWO_FACTOR_KEY, 'function')
};